import React, { useState } from 'react';
import { Nav, Navbar, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import '../style/style.css';
import LangButton from './LangButton';
import SideBar from './DropdownEdit';

export default function NavBar({ mainImg, isAdmin }) {
  const [colorChange, setColorchange] = useState(false);

  const { t } = useTranslation();

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };

  window.addEventListener('scroll', changeNavbarColor);
  return (
    <Container fluid className="main-container">
      <Container
        className="main-img"
        fluid
        style={{ padding: '0', backgroundImage: `url(${process.env.REACT_APP_API_URI}/api/image/${mainImg[0].image})` }}
      />
      <Container fluid>
        <Navbar
          collapseOnSelect
          expand="lg"
          style={{ position: 'fixed', zIndex: '100' }}
          className={
            colorChange ? 'navbar-color-change' : 'navbar navbar-container'
          }
        >
          <Navbar.Brand
            className="navbar md-auto"
            href="#"
            style={{ cursor: 'pointer' }}
          >
            <img
              className="navbar-logo"
              src={`${process.env.REACT_APP_API_URI}/api/image/${mainImg[1].image}`}
              width="100"
              height="70"
              alt="novadinamica.com"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className={isAdmin ? 'collapse-navbar-edit' : ''}
          >
            <Nav
              className={
                isAdmin ? 'nav-items ms-auto navlink-edit' : 'nav-items ms-auto'
              }
            >
              <Nav.Link href="#sobre">{t('about')}</Nav.Link>
              <Nav.Link href="#servicos">{t('services')}</Nav.Link>
              <Nav.Link href="#contactos">{t('contacts')}</Nav.Link>
              <Nav.Link href="#lang">
                <LangButton />
              </Nav.Link>
              <Nav
                id="edit-link"
                style={{ justifyContent: 'flex-end' }}
                href=""
              >
                {isAdmin ? <SideBar /> : ''}
              </Nav>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </Container>
  );
}

NavBar.propTypes = {
  mainImg: PropTypes.instanceOf(Array).isRequired,
  isAdmin: PropTypes.bool,
};

NavBar.defaultProps = {
  isAdmin: false,
};
